module.exports = __webpack_public_path__ + "static/media/frame2.daad2317.jpg";